import { render, staticRenderFns } from "./StatementDownload.vue?vue&type=template&id=b1ae1748&scoped=true"
import script from "./StatementDownload.vue?vue&type=script&lang=ts"
export * from "./StatementDownload.vue?vue&type=script&lang=ts"
import style0 from "./StatementDownload.vue?vue&type=style&index=0&id=b1ae1748&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ae1748",
  null
  
)

export default component.exports